"use client";

import { Menu } from "@chakra-ui/react";
import GenericIcon from "@/shared/ui/actions/GenericIcon";
import WithMenu from "@/shared/ui/actions/WithMenu";
import WithMenuItem from "@/shared/ui/actions/WithMenuItem";
import { iconSizePresets } from "@/shared/config/iconSizePresets";

interface SearchCriteriaMenuProps {
  isBusy: boolean;
  isMobileDevice: boolean;
  predictiveFiltering: boolean;
  regularCriteriaCount: number;
  canDeleteSelected: boolean;
  onExtract: () => Promise<void>;
  onTogglePredictiveFiltering: () => void;
  onClearSelected: () => void;
  onDeleteSelected: () => Promise<void>;
}

export default function SearchCriteriaMenu({
  isBusy,
  isMobileDevice,
  predictiveFiltering,
  regularCriteriaCount,
  canDeleteSelected,
  onExtract,
  onTogglePredictiveFiltering,
  onClearSelected,
  onDeleteSelected,
}: SearchCriteriaMenuProps) {
  return (
    <WithMenu
      hideMenu={isBusy}
      isLoading={isBusy}
      zIndex="max"
      size={isMobileDevice ? "sm" : "md"}
    >
      <Menu.ItemGroup>
        <Menu.ItemGroupLabel fontSize={isMobileDevice ? "xs" : "sm"}>
          Criteria
        </Menu.ItemGroupLabel>

        <WithMenuItem
          value="extract_criteria"
          humanReadable="Prepare criteria from focus lens"
          onClick={onExtract}
        >
          <GenericIcon icon="extract" size={iconSizePresets.chipAction} />
          Prepare
        </WithMenuItem>

        <WithMenuItem
          value="toggle_predictive_filtering"
          humanReadable="Toggle predictive filtering"
          tone={predictiveFiltering ? "success" : undefined}
          onClick={onTogglePredictiveFiltering}
        >
          <GenericIcon
            icon={predictiveFiltering ? "toggle_on" : "toggle_off"}
            size={iconSizePresets.chipAction}
          />
          Filtering
        </WithMenuItem>
      </Menu.ItemGroup>

      <Menu.ItemGroup>
        <Menu.Separator />
        <Menu.ItemGroupLabel fontSize={isMobileDevice ? "xs" : "sm"}>
          Actions ({regularCriteriaCount})
        </Menu.ItemGroupLabel>

        <WithMenuItem
          value="clear_criteria"
          humanReadable="Unselect all selected criteria"
          tone="warning"
          onClick={onClearSelected}
        >
          <GenericIcon icon="unselect" size={iconSizePresets.chipAction} />
          Unselect
        </WithMenuItem>

        <WithMenuItem
          value="delete_criteria"
          humanReadable="Delete selected criteria permanently"
          tone="error"
          disabled={!canDeleteSelected}
          onClick={onDeleteSelected}
        >
          <GenericIcon
            icon="delete_permanent"
            size={iconSizePresets.chipAction}
          />
          Delete
        </WithMenuItem>
      </Menu.ItemGroup>
    </WithMenu>
  );
}
